import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {UPS} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [UPS]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__package_bill_type`]
    : []
}

export default function PackageBillType() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = PackageBillType.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Package Bill Type"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="package_bill_type"
      noEmptyOption
    />
  )
}

PackageBillType.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
